import Clients from './Clients.json';

export default {
  Clients,
};
